import { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Loader2, RefreshCcw } from "lucide-react";

const DEFAULT = "__standard__";

export const LetterpaperPicker = ({ value, onChange, disabled, label = "Briefpapier", testId = "sevdesk-letterpaper", emptyLabel = "Standard-Design (kein Briefpapier)",
  hint = "Wird bei der nächsten Preisfreigabe auf das sevDesk-Angebot angewendet. Speichern nicht vergessen." }) => {
  const [items, setItems] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [manual, setManual] = useState(false);

  const load = async () => {
    setLoading(true); setError("");
    try { const r = await api.get("/integrationen/sevdesk/briefpapiere"); setItems(r.data); }
    catch (e) { setError(e?.response?.data?.detail || "Briefpapiere konnten nicht geladen werden."); setManual(true); }
    finally { setLoading(false); }
  };

  const known = items?.some((i) => i.id === value);
  return (
    <div className="space-y-2" data-testid={`${testId}-picker`}>
      <Label>{label}</Label>
      <div className="flex gap-2 items-center">
        {items ? (
          <Select value={value || DEFAULT} onValueChange={(v) => onChange(v === DEFAULT ? "" : v)}>
            <SelectTrigger className="flex-1 h-auto min-h-9" data-testid={`${testId}-select`}><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value={DEFAULT} data-testid={`${testId}-option-standard`}>{emptyLabel}</SelectItem>
              {value && !known && <SelectItem value={value}>Aktuell gespeichert: {value}</SelectItem>}
              {items.map((i) => (
                <SelectItem key={i.id} value={i.id} data-testid={`${testId}-option-${i.id}`}>
                  <span className="flex items-center gap-3">
                    {i.thumb_base64 ? <img src={i.thumb_base64} alt="" className="w-[60px] h-[60px] object-contain border rounded bg-white" /> : <span className="w-[60px] h-[60px] border rounded bg-slate-50" />}
                    <span>{i.name}{i.default ? " (sevDesk-Standard)" : ""}</span>
                  </span>
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        ) : (
          <div className="flex-1 text-sm text-slate-500" data-testid={`${testId}-current`}>{value ? `Gespeicherte ID: ${value}` : emptyLabel}</div>
        )}
        <Button type="button" variant="outline" onClick={load} disabled={loading || disabled} data-testid={`${testId}-load`}>
          {loading ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <RefreshCcw className="w-4 h-4 mr-2" />} Briefpapiere laden
        </Button>
      </div>
      {error && <p className="text-xs text-rose-700" data-testid={`${testId}-error`}>{error}</p>}
      <button type="button" className="text-xs text-slate-500 underline" onClick={() => setManual(!manual)} data-testid={`${testId}-manual-toggle`}>
        {manual ? "Manuelle Eingabe ausblenden" : "ID manuell eingeben (Expertenmodus)"}
      </button>
      {manual && (
        <Input placeholder="Briefpapier-ID — leer = Standard-Design" value={value || ""} onChange={(e) => onChange(e.target.value.trim())} data-testid={testId === "sevdesk-letterpaper" ? "sevdesk-custom-design-manual" : `${testId}-manual`} />
      )}
      <p className="text-xs text-slate-500">{hint}</p>
    </div>
  );
};
